import React from 'react';
export function OfferingSummary() {
  return <div className="min-h-screen bg-[#f4f7f9] font-sans text-slate-800" data-id="element-510">
      {/* Header Section */}
      <header className="bg-[#0f2546] text-white pt-5 pb-4 px-6 md:px-10" data-id="element-511">
        <div className="max-w-7xl mx-auto" data-id="element-512">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4" data-id="element-513">
            <div data-id="element-514">
              <div className="flex items-center space-x-2 mb-0.5" data-id="element-515">
                <span className="text-2xl font-bold tracking-tight" data-id="element-516">
                  Swedenmark <span className="text-blue-400" data-id="element-517">AI</span>
                </span>
              </div>
              <p className="text-slate-400 text-[10px] tracking-[0.2em] uppercase font-semibold" data-id="element-518">
                AI Automation & Growth Consulting
              </p>
            </div>
            <div className="text-xs text-slate-300 space-y-0.5" data-id="element-519">
              <p data-id="element-520">
                <strong className="text-white" data-id="element-521">For:</strong> Owner-operators
                putting AI to work
              </p>
              <p data-id="element-522">
                <strong className="text-white" data-id="element-523">Model:</strong> Setup + monthly
                retainer
              </p>
              <p data-id="element-524">
                <strong className="text-white" data-id="element-525">Location:</strong> Pompano Beach,
                FL · Nationwide
              </p>
            </div>
          </div>

          <p className="text-slate-300 text-xs leading-relaxed max-w-5xl" data-id="element-526">
            The call that goes to voicemail after 5pm. The lead you follow up on
            three days late. The repetitive work eating your team's week.{' '}
            <strong className="text-white" data-id="element-527">
              That's business slipping through the cracks — and AI can catch it.
            </strong>{' '}
            We find where it'll pay off fastest in your business and build it
            in.
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-3" data-id="element-528">
        <div className="flex flex-col md:flex-row gap-6" data-id="element-529">
          {/* Left Column - Services */}
          <div className="md:w-2/3" data-id="element-530">
            <h2 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 border-b border-slate-200 pb-1" data-id="element-531">
              The Three Offers
            </h2>

            <div className="space-y-1.5 mb-3" data-id="element-532">
              {/* Get more business */}
              <div className="bg-white rounded-lg border border-slate-200 border-l-4 border-l-blue-500 shadow-sm overflow-hidden" data-id="element-533">
                <div className="flex flex-col sm:flex-row" data-id="element-534">
                  <div className="sm:w-24 shrink-0 flex flex-col items-center justify-center p-2 bg-blue-50/60 border-b sm:border-b-0 sm:border-r border-blue-100" data-id="element-535">
                    <span className="text-sm font-extrabold text-blue-600 leading-tight tracking-tight text-center" data-id="element-536">
                      Grow
                    </span>
                    <span className="text-[8px] font-semibold text-blue-600/70 uppercase tracking-wider mt-0.5" data-id="element-537">
                      Flagship
                    </span>
                  </div>
                  <div className="p-2 flex-1" data-id="element-538">
                    <h3 className="font-bold text-slate-900 mb-1 text-xs" data-id="element-539">
                      Get more business
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-x-3 gap-y-0.5" data-id="element-540">
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-541">
                        <span className="text-blue-500 mt-0.5 shrink-0" data-id="element-542">▸</span>
                        <span data-id="element-543">Answer every call, day or night</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-544">
                        <span className="text-blue-500 mt-0.5 shrink-0" data-id="element-545">▸</span>
                        <span data-id="element-546">Follow up on every lead in seconds</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-547">
                        <span className="text-blue-500 mt-0.5 shrink-0" data-id="element-548">▸</span>
                        <span data-id="element-549">Nurture the maybes, then create new demand</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Keep your customers happy */}
              <div className="bg-white rounded-lg border border-slate-200 border-l-4 border-l-emerald-500 shadow-sm overflow-hidden" data-id="element-550">
                <div className="flex flex-col sm:flex-row" data-id="element-551">
                  <div className="sm:w-24 shrink-0 flex flex-col items-center justify-center p-2 bg-emerald-50/60 border-b sm:border-b-0 sm:border-r border-emerald-100" data-id="element-552">
                    <span className="text-sm font-extrabold text-emerald-600 leading-tight tracking-tight text-center" data-id="element-553">
                      Serve
                    </span>
                    <span className="text-[8px] font-semibold text-emerald-600/70 uppercase tracking-wider mt-0.5" data-id="element-554">
                      Retain
                    </span>
                  </div>
                  <div className="p-2 flex-1" data-id="element-555">
                    <h3 className="font-bold text-slate-900 mb-1 text-xs" data-id="element-556">
                      Keep your customers happy
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-x-3 gap-y-0.5" data-id="element-557">
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-558">
                        <span className="text-emerald-500 mt-0.5 shrink-0" data-id="element-559">
                          ▸
                        </span>
                        <span data-id="element-560">Instant, accurate answers at 2am</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-561">
                        <span className="text-emerald-500 mt-0.5 shrink-0" data-id="element-562">
                          ▸
                        </span>
                        <span data-id="element-563">Across chat, email, and SMS</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-564">
                        <span className="text-emerald-500 mt-0.5 shrink-0" data-id="element-565">
                          ▸
                        </span>
                        <span data-id="element-566">Your team stops fielding the same questions</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Run the back office on autopilot */}
              <div className="bg-white rounded-lg border border-slate-200 border-l-4 border-l-violet-500 shadow-sm overflow-hidden" data-id="element-567">
                <div className="flex flex-col sm:flex-row" data-id="element-568">
                  <div className="sm:w-24 shrink-0 flex flex-col items-center justify-center p-2 bg-violet-50/60 border-b sm:border-b-0 sm:border-r border-violet-100" data-id="element-569">
                    <span className="text-sm font-extrabold text-violet-600 leading-tight tracking-tight text-center" data-id="element-570">
                      Save
                    </span>
                    <span className="text-[8px] font-semibold text-violet-600/70 uppercase tracking-wider mt-0.5" data-id="element-571">
                      Efficiency
                    </span>
                  </div>
                  <div className="p-2 flex-1" data-id="element-572">
                    <h3 className="font-bold text-slate-900 mb-1 text-xs" data-id="element-573">
                      Run the back office on autopilot
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-x-3 gap-y-0.5" data-id="element-574">
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-575">
                        <span className="text-violet-500 mt-0.5 shrink-0" data-id="element-576">
                          ▸
                        </span>
                        <span data-id="element-577">The copy-paste between systems, done</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-578">
                        <span className="text-violet-500 mt-0.5 shrink-0" data-id="element-579">
                          ▸
                        </span>
                        <span data-id="element-580">Invoice chasing and paperwork, handled</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-581">
                        <span className="text-violet-500 mt-0.5 shrink-0" data-id="element-582">
                          ▸
                        </span>
                        <span data-id="element-583">Your team gets its week back</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Agentic AI — cross-cutting premium */}
              <div className="bg-white rounded-lg border border-slate-200 border-l-4 border-l-amber-500 shadow-sm overflow-hidden" data-id="element-584">
                <div className="flex flex-col sm:flex-row" data-id="element-585">
                  <div className="sm:w-24 shrink-0 flex flex-col items-center justify-center p-2 bg-amber-50/60 border-b sm:border-b-0 sm:border-r border-amber-100" data-id="element-586">
                    <span className="text-sm font-extrabold text-amber-600 leading-tight tracking-tight text-center" data-id="element-587">
                      Agentic
                    </span>
                    <span className="text-[8px] font-semibold text-amber-600/70 uppercase tracking-wider mt-0.5" data-id="element-588">
                      Premium
                    </span>
                  </div>
                  <div className="p-2 flex-1" data-id="element-589">
                    <h3 className="font-bold text-slate-900 mb-1 text-xs" data-id="element-590">
                      The deep-end version of any offer
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-x-3 gap-y-0.5" data-id="element-591">
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-592">
                        <span className="text-amber-500 mt-0.5 shrink-0" data-id="element-593">
                          ▸
                        </span>
                        <span data-id="element-594">AI running a whole workflow, not one task</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-595">
                        <span className="text-amber-500 mt-0.5 shrink-0" data-id="element-596">
                          ▸
                        </span>
                        <span data-id="element-597">End-to-end — no handoffs or gaps</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-598">
                        <span className="text-amber-500 mt-0.5 shrink-0" data-id="element-599">
                          ▸
                        </span>
                        <span data-id="element-600">A Pro-tier upgrade once wins are proven</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* How You're Charged Section */}
            <div className="bg-[#0f2546] rounded-xl p-3 text-white shadow-lg" data-id="element-601">
              <h2 className="text-[10px] font-bold text-blue-300 uppercase tracking-widest mb-2 border-b border-slate-700 pb-1" data-id="element-602">
                How It Works — Simple, Low-Risk to Start
              </h2>
              <div className="grid md:grid-cols-3 gap-2" data-id="element-603">
                <div className="bg-[#1a365d] p-2 rounded-lg border border-slate-700" data-id="element-604">
                  <h4 className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-605">
                    Setup Fee
                  </h4>
                  <p className="text-[11px] text-slate-200" data-id="element-606">
                    One-time build & integration, sized to{' '}
                    <span className="text-blue-300" data-id="element-607">the scope of the work</span>
                  </p>
                </div>
                <div className="bg-[#1a365d] p-2 rounded-lg border border-slate-700" data-id="element-608">
                  <h4 className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-609">
                    Monthly Retainer
                  </h4>
                  <p className="text-[11px] text-slate-200" data-id="element-610">
                    Ongoing management & optimization —{' '}
                    <span className="text-blue-300" data-id="element-611">keeps improving</span>
                  </p>
                </div>
                <div className="bg-[#1a365d] p-2 rounded-lg border border-slate-700" data-id="element-612">
                  <h4 className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-613">
                    Optional
                  </h4>
                  <p className="text-[11px] text-slate-200" data-id="element-614">
                    Tie part of the fee to{' '}
                    <span className="text-blue-300" data-id="element-615">results</span> — booked
                    appointments, qualified leads
                  </p>
                </div>
              </div>
              <p className="text-[10px] text-slate-400 mt-2" data-id="element-616">
                Start small with one system, prove it, and expand. Exact numbers
                depend on scope — we'll walk you through them on the free audit.
              </p>
            </div>
          </div>

          {/* Right Column - Sidebar */}
          <div className="md:w-1/3 space-y-5" data-id="element-617">
            {/* The Frame */}
            <div data-id="element-618">
              <h2 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 border-b border-slate-200 pb-1.5" data-id="element-619">
                The Frame
              </h2>
              <div className="grid grid-cols-2 gap-2" data-id="element-620">
                <div className="bg-[#0f2546] text-white p-3 rounded-lg flex flex-col justify-center" data-id="element-621">
                  <span className="text-sm font-bold mb-0.5 text-blue-300" data-id="element-622">
                    Grow
                  </span>
                  <span className="text-[9px] text-slate-300 leading-tight" data-id="element-623">
                    Revenue you're leaking — missed calls, slow follow-up,
                    unchased quotes
                  </span>
                </div>
                <div className="bg-[#0f2546] text-white p-3 rounded-lg flex flex-col justify-center" data-id="element-624">
                  <span className="text-sm font-bold mb-0.5 text-blue-300" data-id="element-625">
                    Save
                  </span>
                  <span className="text-[9px] text-slate-300 leading-tight" data-id="element-626">
                    Repetitive work eating your team's time, handed to AI
                  </span>
                </div>
              </div>
            </div>

            {/* Who it's for */}
            <div data-id="element-627">
              <h2 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 border-b border-slate-200 pb-1.5" data-id="element-628">
                Who It's For
              </h2>
              <ul className="space-y-1.5 text-xs text-slate-700" data-id="element-629">
                <li className="flex items-start" data-id="element-630">
                  <span className="text-blue-500 mr-1.5 mt-0.5" data-id="element-631">•</span>
                  Owner-operators who know AI matters but haven't put it to work
                </li>
                <li className="flex items-start" data-id="element-632">
                  <span className="text-blue-500 mr-1.5 mt-0.5" data-id="element-633">•</span>
                  Losing business to missed calls, slow follow-up, or unchased
                  quotes
                </li>
                <li className="flex items-start" data-id="element-634">
                  <span className="text-blue-500 mr-1.5 mt-0.5" data-id="element-635">•</span>
                  Teams buried in the same questions, data entry, and paperwork
                </li>
                <li className="flex items-start" data-id="element-636">
                  <span className="text-blue-500 mr-1.5 mt-0.5" data-id="element-637">•</span>
                  Want it built around how they run, not a generic tool
                </li>
              </ul>
            </div>

            {/* Why Swedenmark AI */}
            <div data-id="element-638">
              <h2 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 border-b border-slate-200 pb-1.5" data-id="element-639">
                Why Swedenmark AI
              </h2>
              <ul className="space-y-2 text-xs text-slate-700" data-id="element-640">
                <li className="flex items-start" data-id="element-641">
                  <div className="bg-[#0f2546] text-white rounded w-4 h-4 flex items-center justify-center mr-2 mt-0.5 shrink-0 text-[9px] font-bold" data-id="element-642">
                    +
                  </div>
                  <p data-id="element-643">
                    <strong className="text-slate-900" data-id="element-644">
                      Built around your business.
                    </strong>{' '}
                    Not the generic tool everyone gets — so it fits, gets used,
                    and you can measure it.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-645">
                  <div className="bg-[#0f2546] text-white rounded w-4 h-4 flex items-center justify-center mr-2 mt-0.5 shrink-0 text-[9px] font-bold" data-id="element-646">
                    ◫
                  </div>
                  <p data-id="element-647">
                    <strong className="text-slate-900" data-id="element-648">
                      Operators who ship.
                    </strong>{' '}
                    Not an agency reselling the same platform to everyone.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-649">
                  <div className="bg-[#0f2546] text-white rounded w-4 h-4 flex items-center justify-center mr-2 mt-0.5 shrink-0 text-[9px] font-bold" data-id="element-650">
                    ▤
                  </div>
                  <p data-id="element-651">
                    <strong className="text-slate-900" data-id="element-652">
                      We build and run it.
                    </strong>{' '}
                    Full deployment, integration, and ongoing management.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-653">
                  <div className="bg-[#0f2546] text-white rounded w-4 h-4 flex items-center justify-center mr-2 mt-0.5 shrink-0 text-[9px] font-bold" data-id="element-654">
                    ◎
                  </div>
                  <p data-id="element-655">
                    <strong className="text-slate-900" data-id="element-656">
                      Skin in the game.
                    </strong>{' '}
                    We can tie part of our fee to the results it produces.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      {/* Footer Section */}
      <footer className="bg-[#0f2546] text-white py-3 px-6 md:px-10 mt-3" data-id="element-657">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-658">
          <div className="md:w-1/2" data-id="element-659">
            <h3 className="text-sm font-bold mb-0.5" data-id="element-660">
              Start with a free audit.
            </h3>
            <p className="text-xs text-slate-400" data-id="element-661">
              We'll show you the three places AI would earn its keep fastest —
              and tell you plainly whether it's worth it. No obligation.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-6 text-xs text-slate-400" data-id="element-662">
            <div data-id="element-663">
              <p className="uppercase text-[9px] tracking-widest mb-0.5" data-id="element-664">
                Model
              </p>
              <p className="text-blue-300" data-id="element-665">Setup + monthly retainer</p>
            </div>
            <div data-id="element-666">
              <p className="uppercase text-[9px] tracking-widest mb-0.5" data-id="element-667">
                First step
              </p>
              <p className="text-blue-300" data-id="element-668">Free audit</p>
            </div>
            <div className="text-right sm:text-left" data-id="element-669">
              <p className="font-bold text-white mb-0.5" data-id="element-670">swedenmark.ai</p>
              <p data-id="element-671">hello@swedenmark.ai</p>
              <p data-id="element-672">Pompano Beach, FL</p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}